
export const TICKETING_PROCESS_DETAILS = 'TicketingProcessDetails'
export const TICKETING_TASK_LIST = 'TicketingTaskList'
